import { NavLink } from 'react-router-dom';
import type { NavItem } from './Sidebar';
import { Icon } from '../ui';
import type { IconName } from '../ui';
import styles from './BottomNav.module.css';

interface BottomNavProps {
  navItems: NavItem[];
}

export default function BottomNav({ navItems }: BottomNavProps) {
  return (
    <nav className={styles.bottomNav}>
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/ap' || item.path === '/admin'}
          className={({ isActive }) =>
            `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
          }
        >
          <span className={styles.navIcon}><Icon name={item.icon as IconName} size={23} /></span>
          <span className={styles.navLabel}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
